import { DASH_META_ROOT } from '@revelio/auth';

import { fetchJson } from './fetch-util';

export interface ChartSummaryChart {
  title?: string;
  data: Array<Record<string, string | number>>;
}

export interface GetChartSummaryBody {
  prompt?: string;
  minLength?: number;
  maxLength?: number;
  charts?: ChartSummaryChart[];
}

export interface GetChartSummaryResponse {
  summary: string;
  usedLength: number;
  totalLength: number;
}

export const getChartSummary = (body: GetChartSummaryBody) =>
  fetchJson<GetChartSummaryResponse>(
    `${DASH_META_ROOT}/api/build-a-dash/ai-gen/summary`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    }
  );

export interface GetTextAssistBody {
  prompt?: string;
  template: string;
  contentSize?: 'small' | 'medium' | 'large' | 'fullPage';
  metrics?: Array<{
    value: string;
    description: string;
  }>;
  filters?: Array<{
    id: string;
    label: string;
  }>;
}

export interface GetTextAssistResponse {
  template: string;
}

export const getTextAssist = (body: GetTextAssistBody, init?: RequestInit) =>
  fetchJson<GetTextAssistResponse>(
    `${DASH_META_ROOT}/api/build-a-dash/ai-gen/text-assist`,
    {
      method: 'POST',
      body: JSON.stringify(body),
      signal: init?.signal,
    }
  );

export interface GetTextSummaryBody {
  text: string;
  prompt?: string;
  minLength?: number;
  maxLength?: number;
}

export interface GetTextSummaryResponse {
  summary: string;
}

export const getTextSummary = (body: GetTextSummaryBody) =>
  fetchJson<GetTextSummaryResponse>(
    `${DASH_META_ROOT}/api/build-a-dash/ai-gen/text-summary`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    }
  );
